export const connectionsRoot = '/connections';

export const suggestionsSubpath = `/suggestions`;
export const newFollowersSubpath = `/new-followers`;

export const suggestedConnectionsPath: string = `${connectionsRoot}${suggestionsSubpath}`;
export const newFollowersPath: string = `${connectionsRoot}${newFollowersSubpath}`;
